var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStatecorpsos = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#22262A",
    strokeWidth: 1.339,
    d: "M13 25.25c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#22262A",
    d: "M6.587 17.357v1.02h12.83v-1.02H6.588M6.406 18.74h-.513v1.098h14.218V18.74H6.406M9.35 12.52H7.628v4.475h1.72zM19.945 10.085h.555l-1.67-.762h-.002l-5.826-2.659-1.717.786-2.503 1.14c-1.101.5-2.153.978-3.282 1.495h14.444999999999999M10.156 8.91c.47-.192.894-.388 1.343-.596a34 34 0 0 1 1.434-.636.18.18 0 0 1 .142.003l2.777 1.231a.181.181 0 0 1-.073.347h-5.554a.181.181 0 0 1-.069-.35"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#22262A",
    d: "M13 8.045c-.482.199-.922.402-1.349.6l-.552.253h3.825zM19.764 10.447H6.24v1.711h13.524000000000001zM13.862 12.52h-1.72v4.475h1.72zM18.375 12.52h-1.72v4.475h1.72z"
  })));
};
export default SvgStatecorpsos;